// import * as React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { PageWrap } from '../layouts';
import { H1, H3 } from '../typography';

const ErrorMessageContainer = styled.div`
  & h1 {
    text-align: center;
    font-size: ${props => props.theme.fontSize[6]};
  }
`;

const NoMatch = () => (
  <PageWrap justifyContent="center" alignItems="center">
    <ErrorMessageContainer>
      <H1 as="h1" color="primary">
        404
      </H1>
      <br />
      <H3>Whoops! Looks like there's nothing to see here.</H3>
      <br />
    </ErrorMessageContainer>
    <Helmet title="404" />
  </PageWrap>
);

export default NoMatch;
